import { isEqual } from 'lodash';
import { ParameterType, ParametricViewer } from './index';
import { ShapeDiverValue } from './types';
import { dataURItoBlob } from '../utils';

const dataUrlCache: Record<string, { contentId: string; dataUrl: string }> = {};

export function updateDataUrlCache(
  inputId: string,
  contentId: string,
  dataUrl: string
): void {
  // console.log('Update DataURL Cache', inputId);
  dataUrlCache[inputId] = {
    contentId,
    dataUrl,
  };
}

type UpdateParamData = { id: string; value: ShapeDiverValue | Blob };

export function extractUpdates(
  viewer: ParametricViewer,
  newValues: Record<string, ShapeDiverValue>
): UpdateParamData[] {
  const { data: currentParams } = viewer.parameters.get();

  return Object.keys(newValues)
    .filter((paramId) => {
      const param = currentParams.find((cp) => cp.id === paramId);

      if (!param) {
        console.warn('Unable to find parameter in existing model', paramId);
        return false;
      }

      const { value } = param;
      if (param.type === ParameterType.FILE) {
        const cacheValue = dataUrlCache[paramId];
        if (newValues[paramId] === param.value) return false;
        return !(
          cacheValue &&
          cacheValue.dataUrl === newValues[paramId] &&
          cacheValue.contentId === param.value
        );
      }

      return !isEqual(value, newValues[paramId]);
    })
    .map((paramId) => {
      const param = currentParams.find((cp) => cp.id === paramId);
      const value =
        param?.type === ParameterType.FILE
          ? dataURItoBlob(newValues[paramId] as string)
          : newValues[paramId];

      return { id: paramId, value };
    });
}
